import Router from 'next/router'
import {CONFIRMATION_PAGE_PATH} from 'utils/urls'

/**
 * Next makes `prefetch` a no-op outside production, so this warms nothing in
 * development. A failed warm-up must not reach the booking in flight.
 */
export const preloadConfirmation = (): void => {
  Router.prefetch(CONFIRMATION_PAGE_PATH).catch(() => {
    // The route loads its bundle on navigation anyway.
  })
}
